import { useState } from "react";
import { useProtectedAPI } from "./apiService";
import useSWR from "swr";



export const useGetMessagesSWR = (forum_id, topic_id) => {
    const protectedAPI = useProtectedAPI()
    const fetcher = (url) => protectedAPI.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR( (forum_id && topic_id) ? `/forums/${forum_id}/topics/${topic_id}/messages` : null, fetcher, {refreshInterval: 60 * 1000, refreshWhenHidden: true});

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useGetMessages = () => {
    const protectedAPI = useProtectedAPI()

    const getMessages = async (forum_id, topic_id) => {
        const url = `/forums/${forum_id}/topics/${topic_id}/messages`
        const response = await protectedAPI.get(url)
        return response.data
    }
    
    return getMessages
}



export const useGetMessage = () => {
    const protectedAPI = useProtectedAPI()

    const getMessage = async (forum_id, topic_id, message_id) => {
        const url = `/forums/${forum_id}/topics/${topic_id}/messages/${message_id}`
        const response = await protectedAPI.get(url)
        return response.data
    }
    
    return getMessage
}



export const useCreateMessage = () => {
    const protectedAPI = useProtectedAPI();

    const createMessage = async (forum_id, topic_id, data) => {
        const response = await protectedAPI.post(`/forums/${forum_id}/topics/${topic_id}/messages`, data)
        return response.data
    };

    return createMessage;
}



export const useUpdateMessage = () => {
    const protectedAPI = useProtectedAPI();

    const updateMessage = async (forum_id, topic_id, message_id, data) => {
        const response = await protectedAPI.put(`/forums/${forum_id}/topics/${topic_id}/messages/${message_id}`, data)
        return response.data
    };

    return updateMessage;
}



export const useDeleteMessage = () => {
    const protectedAPI = useProtectedAPI();

    const deleteMessage = async (forum_id, topic_id, message_id) => {
        const response = await protectedAPI.delete(`/forums/${forum_id}/topics/${topic_id}/messages/${message_id}`)
        return response.data
    };

    return deleteMessage;
}



export const useUploadFile = () => {
    const protectedAPI = useProtectedAPI();
    const [progress, setProgress] = useState(null);

    const uploadFile = async (forum_id, topic_id, message_id, file, inline) => {
        const formData = new FormData();
        formData.append("file", file);

        const response = await protectedAPI.post(`/forums/${forum_id}/topics/${topic_id}/messages/${message_id}/attach?inline=${inline}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setProgress(percentCompleted);
            },
            timeout: 0
        });
        return response.data
    };

    return { uploadFile, progress };
}



export const useDeleteFile = () => {
    const protectedAPI = useProtectedAPI();

    const deleteFile = async (forum_id, topic_id, message_id, uuid) => {
        const response = await protectedAPI.delete(`/forums/${forum_id}/topics/${topic_id}/messages/${message_id}/attach/${uuid}`);
        return response.data
    };

    return deleteFile;
}